import {
  getEntityTemplate,
  createEntity,
  getCityTemplate,
  uploadCompanyLogo,
  getEntities,
  updateCreditLimit,
  getEntityById,
  updateEntity,
  getTicketTemplate,
  getAdjustmentsTemplate,
  getAgreementsTemplate,
  createAdjustment,
  getPaymentsTemplate,
  createPayments,
  cerateTickets,
  cerateTicketsDocument,
  createAgreement,
  getAgreements,
  getEntityTickets,
  deleteTickets,
  renewal,
  getEntityCustomers,
  getDisbursements,
  getTransactions,
  cancelRemark,
  downloadTicketDocument,
  getEditTicketTemplate,
  updateTicket,
  cancelTicketTemplate,
  cancelTicket,
  viewTicketData,
} from "@/http/entity";
import { getLoc, getTicketSubCategory } from "@/http/customer/customer";

export default {
  namespaced: true,
  state: {
    list: [],
    template: {},
    entityDetail: {},
    tickets: [],
    customers: [],
    ticketTemplate: {},
    cityTemplate: {},
    oneTimeSaleItem: {},
    adjustmentsTemplate: [],
    disbursements: {
      pageItems: [],
    },
    transactions: [],
    agreementsTemplete: {},
    paymentTemplate: {},
    createEntityResponse: {},
    updateEntityResponse: {},
    createTicketResponse: null,
    createAgreementResponse: null,
    locationList: [],
    agreementDetails: null,
    ticketSubcategory: [],
    editTicketTemplate: {},
  },
  actions: {
    async setEntities({ commit }, data) {
      try {
        const resp = await getEntities();
        commit("SET_ENTITIES", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw error;
      }
    },
    async setTemplate({ commit }) {
      try {
        const template = await getEntityTemplate();
        commit("SET_TEMPLATE", template.data);
      } catch (error) {
        throw error;
      }
    },
    async setEntityDetail({ commit }, data) {
      try {
        const response = await getEntityById(data);
        commit("SET_ENTITIE", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async setEntityTickets({ commit }, data) {
      try {
        const response = await getEntityTickets(data);
        commit("SET_ENTITY_TICKETS", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async setEntityCustomers({ commit }, data) {
      try {
        const response = await getEntityCustomers(data);
        commit("SET_ENTITY_CUSTOMERS", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async setTicketTemplate({ commit }) {
      try {
        const response = await getTicketTemplate();
        commit("SET_TICKET_TEMPLATE", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async setAdjustmentsTemplate({ commit }) {
      try {
        const response = await getAdjustmentsTemplate();
        commit("SET_ADJUSTMENTS_TEMPLATE", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async updateEntities({ commit }, data) {
      try {
        const resp = await updateEntity(data.id, data.data);
        commit("UPDATE_ENTITIES", resp.data);

        return resp;
      } catch (error) {
        throw error;
      }
    },
    async setDisbursements({ commit }, data) {
      try {
        const response = await getDisbursements(data);
        commit("SET_DISBURSEMENTS", response.data.pageItems);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async setTransactions({ commit }, data) {
      try {
        const response = await getTransactions(data);
        commit("SET_TEANSACTIONS", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async setAgreementsTemplate({ commit }) {
      try {
        const response = await getAgreementsTemplate();
        commit("SET_AGREEMENTS_TEMPLATE", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async setPaymentsTemplate({ commit }) {
      try {
        const response = await getPaymentsTemplate();
        commit("SET_PAYMENTS_TEMPLATE", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async setCityTemplate({ commit }, data) {
      try {
        const response = await getCityTemplate(data);
        commit("SET_CITY_TEMPLATE", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async setUpdateCreditLimit({ commit }, data) {
      try {
        const resp = await updateCreditLimit(data.id, data.credit);
        // commit(UPDATE_CREDIT_LIMIT,data)
      } catch (error) {
        throw error;
      }
    },
    async createEntityAction({ commit }, data) {
      try {
        const resp = await createEntity(data);
        commit("CREATE_ENTITY", resp.data);
        return resp;
      } catch (error) {
        throw error;
      }
    },
    async uploadCompanyLogoAction({ commit }, data) {
      try {
        const resp = await uploadCompanyLogo(data.id, data.formData);
      } catch (error) {
        throw error;
      }
    },

    async createAdjustmentAction({ commit }, data) {
      try {
        await createAdjustment(data.id, data.data);
      } catch (error) {
        throw error;
      }
    },

    async createPaymentAction({ commit }, data) {
      try {
        await createPayments(data.id, data.data);
      } catch (error) {
        throw error;
      }
    },
    async createTicketAction({ commit }, data) {
      try {
        const resp = await cerateTickets(data.id, data.data);
        commit("CREATE_TICKETS_RESPONSE", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw error;
      }
    },
    async createTicketDocAction({ commit }, data) {
      try {
        await cerateTicketsDocument(data.id, data.data);
      } catch (error) {
        throw error;
      }
    },
    async createAgreementAction({ commit }, payload) {
      try {
        const resp = await createAgreement(payload);
        commit("CREATE_AGREEMENT_RESPONSE", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw error;
      }
    },
    async getAgreementsList({ commit }, data) {
      try {
        const response = await getAgreements(data);
        commit("GET_AGREEMENTS_LIST", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async deleteTicketAction({ commit }, id) {
      try {
        await deleteTickets(id);
      } catch (error) {
        throw error;
      }
    },
    async setRenewal({ commit }, data) {
      try {
        await renewal(data);
      } catch (error) {
        throw error;
      }
    },
    async setCancelRemark({ commit }, payload) {
      try {
        await cancelRemark(payload.id, payload.data);
      } catch (error) {
        throw error;
      }
    },

    async entityGetLocationAction({ commit }, data) {
      try {
        const response = await getLoc(data);
        commit("ENTITY_LOC_ACTION", response.data.officeOptions);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async setTicketSubcategory({ commit }, data) {
      try {
        const response = await getTicketSubCategory(data);
        commit("SET_TICKET_SUBCATEGORY", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
    async downloadTicketFile({ commit }, payload) {
      try {
        const response = await downloadTicketDocument(
          payload.entityId,
          payload.id
        );
        return response;
      } catch (error) {
        throw error;
      }
    },
    async getEditTicketData({ commit }, data) {
      try {
        const resp = await getEditTicketTemplate(data.entityId, data.ticketId);
        commit("GET_EDIT_TICKET_DATA", resp.data);
        return resp;
      } catch (error) {
        throw error;
      }
    },
    async updateTicketAction({ commit }, data) {
      try {
        const resp = await updateTicket(data.id, data.data);
        commit("CREATE_TICKETS_RESPONSE", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw error;
      }
    },
    async getCancelTicketTemplate({ commit }, data) {
      try {
        const resp = await cancelTicketTemplate(data);
        return resp.data;
      } catch (error) {
        throw error;
      }
    },
    async cancelTicketAction({ commit }, data) {
      try {
        const resp = await cancelTicket(data.id, data.data);
        return resp.data;
      } catch (error) {
        throw error;
      }
    },
    async getTicketInfo({ commit }, data) {
      try {
        const resp = await viewTicketData(data.entityId, data.id);
        return resp.data;
      } catch (error) {
        throw error;
      }
    },
  },
  mutations: {
    SET_ENTITIES(state, payload) {
      Object.assign(state, { list: payload });
    },
    SET_TEMPLATE(state, payload) {
      Object.assign(state, { template: payload });
    },
    SET_ENTITIE(state, payload) {
      Object.assign(state, { entityDetail: payload });
    },
    SET_ENTITY_TICKETS(state, payload) {
      Object.assign(state, { tickets: payload });
    },
    SET_ENTITY_CUSTOMERS(state, payload) {
      Object.assign(state, { customers: payload });
    },
    SET_TICKET_TEMPLATE(state, payload) {
      Object.assign(state, { ticketTemplate: payload });
    },
    SET_ADJUSTMENTS_TEMPLATE(state, payload) {
      Object.assign(state, { adjustmentsTemplate: payload });
    },
    UPDATE_ENTITIES(state, payload) {
      Object.assign(state, { updateEntityResponse: payload });
    },
    SET_DISBURSEMENTS(state, payload) {
      Object.assign(state, { disbursements: payload });
    },
    SET_TEANSACTIONS(state, payload) {
      Object.assign(state, { transactions: payload });
    },
    SET_AGREEMENTS_TEMPLATE(state, payload) {
      Object.assign(state, { agreementsTemplete: payload });
    },
    SET_PAYMENTS_TEMPLATE(state, payload) {
      Object.assign(state, { paymentTemplate: payload });
    },
    SET_CITY_TEMPLATE(state, payload) {
      Object.assign(state, { cityTemplate: payload });
    },
    CREATE_ENTITY(state, payload) {
      Object.assign(state, { createEntityResponse: payload });
    },
    CREATE_TICKETS_RESPONSE(state, payload) {
      Object.assign(state, { createTicketResponse: payload });
    },
    CREATE_AGREEMENT_RESPONSE(state, payload) {
      Object.assign(state, { createAgreementResponse: payload });
    },
    GET_AGREEMENTS_LIST(state, payload) {
      Object.assign(state, { agreementDetails: payload });
    },
    ENTITY_LOC_ACTION(state, payload) {
      Object.assign(state, { locationList: payload });
    },
    SET_TICKET_SUBCATEGORY(state, payload) {
      Object.assign(state, { ticketSubcategory: payload });
    },
    GET_EDIT_TICKET_DATA(state, payload) {
      Object.assign(state, { editTicketTemplate: payload });
    },
  },
  getters: {
    getEntityList(state) {
      return state.list;
    },
    template(state) {
      return state.template;
    },
    getEntityDetail(state) {
      return state.entityDetail;
    },
    getEntityTickets(state) {
      return state.tickets;
    },
    getEntityCustomers(state) {
      return state.customers;
    },
    getTicketTemplate(state) {
      return state.ticketTemplate;
    },
    getCityTemplate(state) {
      return state.cityTemplate;
    },
    getAdjustmentsTemplate(state) {
      return state.adjustmentsTemplate;
    },
    getDisbursements(state) {
      return state.disbursements;
    },
    getTransactions(state) {
      return state.transactions;
    },
    getAgreementsTemplate(state) {
      return state.agreementsTemplete;
    },
    getPaymentsTemplate(state) {
      return state.paymentTemplate;
    },
    getAgreementsList(state) {
      return state.agreementDetails;
    },
    getOneTimeSaleItem(state) {
      return state.oneTimeSaleItem;
    },
  },
};
